import currentOrgConfig from './current-org-config';
import type { OrgConfig } from './types';

const orgConfig = currentOrgConfig as unknown as OrgConfig;

export const ADDRESS_INPUTS = [
  {
    label: 'Pincode',
    placeholder: 'Pincode',
    minLength: 0,
    maxLength: 6,
    inputType: 'number',
    validation: {
      fn: '(e) => { return e?.length > 0; }',
      message: 'Pincode must not be empty'
    },
    fieldName: 'pincode'
  },
  {
    label: 'Line 1',
    placeholder: 'Line 1',
    minLength: 0,
    maxLength: 120,
    inputType: 'field',
    validation: {
      fn: '(e) => { return e?.length > 0; }',
      message: 'Line 1 must not be empty'
    },
    fieldName: 'line1'
  },
  {
    label: 'Landmark',
    placeholder: 'Landmark',
    minLength: 0,
    maxLength: 120,
    inputType: 'field',
    validation: {
      fn: '(e) => { return true }'
    },
    fieldName: 'landmark',
    required: false
  },
  {
    label: 'Village/Town/City',
    placeholder: 'Village/Town/City',
    inputType: 'field',
    validation: {
      fn: '(e) => { return e?.length > 0; }',
      message: 'VTC must not be empty'
    },
    fieldName: 'vtc'
  },
  {
    label: 'State',
    placeholder: 'State',
    inputType: 'field',
    validation: {
      fn: '(e) => { return e?.length > 0; }',
      message: 'State must not be empty'
    },
    fieldName: 'state',
    gridSize: 6
  },
  {
    label: 'District',
    placeholder: 'District',
    inputType: 'field',
    validation: {
      fn: '(e) => { return e?.length > 0; }',
      message: 'District must not be empty'
    },
    fieldName: 'district',
    gridSize: 6
  },
  {
    hidden: true,
    label: 'Country',
    placeholder: 'Country',
    inputType: 'field',
    validation: {
      fn: '(e) => { return true }'
    },
    fieldName: 'country'
  },
  {
    hidden: true,
    label: 'Care of',
    placeholder: 'Care of',
    inputType: 'field',
    validation: {
      fn: '(e) => { return true }'
    },
    fieldName: 'careOf'
  },
  {
    hidden: true,
    label: 'Locality',
    placeholder: 'Locality',
    inputType: 'field',
    validation: {
      fn: '(e) => { return true }'
    },
    fieldName: 'locality'
  },
  {
    hidden: true,
    label: 'City',
    placeholder: 'City',
    inputType: 'field',
    validation: {
      fn: '(e) => { return true }'
    },
    fieldName: 'city'
  }
];

export const CURRENT_ADDRESS_INPUTS = ADDRESS_INPUTS.map((r, idx) => {
  const obj: any = {
    ...r,
    fieldName: `currentAddress.${r.fieldName}`,
    nested: true
  };
  if (idx === 0) {
    obj.sectionTitle = 'Current Address';
  }
  return obj;
});

export const PERMANENT_ADDRESS_INPUTS = ADDRESS_INPUTS.map((r, idx) => {
  const obj: any = {
    ...r,
    fieldName: `permanentAddress.${r.fieldName}`,
    nested: true
  };
  if (idx === 0) {
    obj.sectionTitle = 'Permanent Address';
  }
  return obj;
});

export const getAddnConfigInput = (
  fieldName: string,
  label: string,
  isRequired: boolean | undefined,
  inputType = 'field',
  disabled = false,
  skippable = false
) => ({
  label: label,
  placeholder: label,
  inputType,
  validation: {
    fn: isRequired ? '(e) => e' : '(e) => true',
    message: 'Required'
  },
  required: isRequired,
  fieldName,
  disabled,
  skippable
});

export type TawkToConfig = { propertyId: string, widgetId: string } | null;

export const tawkToConfig = (): TawkToConfig => {
  if (orgConfig?.TAWKTO) {
    return orgConfig.TAWKTO;
  }
  // switch (org) {
  //   case 'WES': {
  //     if (import.meta.env.VITE_WES_AUTH) {
  //       return {
  //         propertyId: '661d22fd1ec1082f04e27249',
  //         widgetId: '1hrgt1cjg'
  //       };
  //     }
  //     return null;
  //   }
  //   case 'GCE': {
  //     if (import.meta.env.VITE_GCE_AUTH) {
  //       return {
  //         propertyId: '672b17184304e3196addc76d',
  //         widgetId: '1ic054f0v'
  //       };
  //     }
  //     return null;
  //   }
  //   case 'ECE': {
  //     if (import.meta.env.VITE_ECE_AUTH) {
  //       return {
  //         propertyId: '672b17184304e3196addc76d',
  //         widgetId: '1ic054f0v'
  //       };
  //     }
  //     return null;
  //   }
  //   case 'EP': {
  //     // if (import.meta.env.VITE_EP_AUTH) {
  //     //   return {
  //     //     propertyId: '67c06d09f65e72190d16ba72',
  //     //     widgetId: '1il3qjs50'
  //     //   };
  //     // }
  //     return null;
  //   }
  //   case 'TEST': {
  //     return {
  //       propertyId: '661d22fd1ec1082f04e27249',
  //       widgetId: '1hrgt1cjg'
  //     };
  //   }
  //   default:
  //     return null;
  // }
  return null;
};

export const ADDRESS_INPUTS_MAP: Record<string, unknown[]> = {
  currentAddress: CURRENT_ADDRESS_INPUTS,
  permanentAddress: PERMANENT_ADDRESS_INPUTS
};

export const getEducationNameField = (name: string, label: string) => ({
  label,
  placeholder: label,
  inputType: 'field',
  validation: {
    fn: '(e) => { return e?.length >= 1; }',
    message: 'Name must not be empty'
  },
  fieldName: name,
  disabled: true,
  getProfileValue: `(profile) => profile?.profileDetails?.name`,
  helperTextJSXKey: name
});

export const MARKSHEET_INPUT = {
  label: 'Upload Marksheet',
  placeholder: '',
  inputType: 'file',
  validation: {
    fn: '(e) => { return e?.length >= 1; }',
    message: 'Upload Education Marksheet'
  },
  fieldName: 'Marksheet',
  shouldRunOcrCheck: true,
  disableUpload: true,
  allowedFileTypes: ['application/pdf'],
  visibility: {
    fn: "(fields)=> (fields?.degreeStatus !== 'DEGREE_ONLY_NO_MARKSHEET')"
  },
  requiredFn: "(fields)=> (fields?.degreeStatus !== 'DEGREE_ONLY_NO_MARKSHEET')"
};
